import { BrowserRouter } from "react-router-dom";
import "./App.css";
import "./styles/Transitions.css";
import TransitionWrapper from "./pages/TransitionWrapper"; // import the new component

function App() {
  return (
    <BrowserRouter>
      <TransitionWrapper />
    </BrowserRouter>
  );
}

export default App;
